import React from 'react';
import PropTypes from 'prop-types';
import LocalizationConsumer from "../../../../l10n/localization-context";

export default class StyleOptions extends React.Component
{
  static propTypes = {
    isHidden: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    linkStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
    linkStyle: PropTypes.string.isRequired,
    linkStyleIframeSrc: PropTypes.string.isRequired
  };

  constructor(props)
  {
    super(props);
    this.iframeRef = React.createRef();

    this.document = null;
    this.activeLink = null;
    this.allLinksOuterContainer = null;
    this.allLinksContainer = null;
  }

  state =
  {
    isDropdownOpen: false
  };

  toggleDropdownOpen = () =>
  {
    const { isDropdownOpen } = this.state;

    this.setState({ isDropdownOpen: !isDropdownOpen });

    const position = isDropdownOpen ? 'absolute' : 'static';
    const visibility = isDropdownOpen ? 'hidden' : 'visible';

    const top = isDropdownOpen ? '-12000px' : '0';
    const left =  isDropdownOpen ? '-12000px' : '0';

    this.allLinksOuterContainer.style.position = position;
    this.allLinksOuterContainer.style.visibility = visibility;
    this.allLinksOuterContainer.style.top = top;
    this.allLinksOuterContainer.style.left = left;


  };

  changeSelectedLink = (classNames) =>
  {
    const { onChange } = this.props;

    this.activeLink.className = classNames;
    onChange(classNames);
  };

  handleEventContentsClick = (event) =>
  {
    const classNames = event.target.getAttribute('data-class-names');

    if (classNames !== null)
    {
      this.changeSelectedLink(classNames);
    }

    this.toggleDropdownOpen();
  };

  populateLinksList = () =>
  {
    const { linkStyles, linkStyle } = this.props;
    const linkClasses = ['', ...linkStyles];

    const renderLink = (className) =>
    {
      const element = this.document.createElement('div');
      element.className = '-wa-link-preview__dropdown-item';
      element.innerHTML = `<div class="-wa-link-preview__dropdown-subitem">
          <span><a class="${className}" href="javascript:void(0)">Sample link</a></span>
          </div><div class="-wa-link-preview__dropdown-overlay" data-class-names="${className}"></div>`;

      return element;
    };

    this.activeLink.className = linkStyle;

    const linkElements = linkClasses.map(renderLink);
    const linkHolder = this.document.createElement('div');
    linkElements.forEach( link => linkHolder.appendChild(link));
    this.allLinksContainer.appendChild(linkHolder);
  };

  handleIframeLoad = () =>
  {
    this.document = this.iframeRef.current.contentWindow.document;
    this.activeLink = this.document.getElementById('-wa-link-preview__id-active-link');
    this.allLinksContainer = this.document.getElementById('-wa-link-preview__id-all-links-container');
    this.allLinksOuterContainer = this.document.getElementById('-wa-link-preview__id-all-links-outer-container');

    this.populateLinksList();

    this.document.body.addEventListener('click', this.handleEventContentsClick);
  };


  render()
  {
    const { isHidden, linkStyleIframeSrc } = this.props;

    if (isHidden || !linkStyleIframeSrc) return null;

    const iframeHeight = this.state.isDropdownOpen ? 354 : 94;

    return (
      <div className="-wa-edit-controls__property-container">
        <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-style">
          <LocalizationConsumer id="insert-link-dialog.style-option.title" />
        </div>
        <div className="-wa-edit-controls__property-control -wa-edit-controls__property-control__style">
          <iframe
            className="-wa-edit-controls__style-selection-iframe"
            title="linkStyleSelector"
            width={277}
            height={iframeHeight}
            frameBorder={0}
            ref={this.iframeRef}
            onLoad={this.handleIframeLoad}
            src={linkStyleIframeSrc}
          />
        </div>
      </div>
    );
  }
};
